import { useContext } from 'react';
import { NATCacheContext, type NATCacheContextType } from '../contexts/NATCacheContext';

export function useNATCache(): NATCacheContextType {
  const context = useContext(NATCacheContext);

  if (context === null) {
    throw new Error('useNATCache must be used within a NATCacheProvider');
  }

  return context;
}
